export default __webpack_public_path__ + "static/media/quiz_bg_mobile.bb6771f6.png";